import React from 'react';
import { UserPlusIcon, UsersIcon, AlertTriangleIcon, ClockIcon, CheckCircleIcon, FileTextIcon, CreditCardIcon } from 'lucide-react';
export function VendorDashboard({
  vendors,
  setCurrentView,
  locale = 'en-US'
}) {
  // Calculate summary statistics
  const totalVendors = vendors.length;
  const activeVendors = vendors.filter(vendor => vendor.vendorStatus?.name === 'Active').length;
  const pendingOnboarding = vendors.filter(vendor => vendor.vendorStatus?.name === 'Pending Onboarding' || vendor.vendorStatus?.name === 'Invited').length;
  // Check for compliance issues
  const complianceIssues = vendors.filter(vendor => !vendor.isCompliant).length;
  // Get recent vendors (sorted by creation date)
  const recentVendors = [...vendors].sort((a, b) => new Date(b.createdUtc).getTime() - new Date(a.createdUtc).getTime()).slice(0, 5);
  // Get vendors with compliance issues
  const vendorsWithIssues = vendors.filter(vendor => !vendor.isCompliant || vendor.complianceIssues.length > 0).slice(0, 5);
  // Navigate to vendor list with status filter
  const handleViewVendorsByStatus = status => {
    // Store the filter preference (in a real app, this would be passed as a prop or through state management)
    sessionStorage.setItem('vendorStatusFilter', status);
    setCurrentView('vendors');
  };
  return <div data-id="element-22063">
      <div className="mb-8 flex justify-between items-center" data-id="element-22064">
        <div data-id="element-22065">
          <h3 className="text-xl font-semibold text-gray-900" data-id="element-22066">
            Vendor Dashboard
          </h3>
          <p className="mt-1 text-sm text-gray-500" data-id="element-22067">
            Overview of your vendor network and compliance status
          </p>
        </div>
        <div className="flex space-x-3" data-id="element-22068">
          <button onClick={() => setCurrentView('onboard-vendor')} className="inline-flex items-center px-4 py-2 border border-transparent text-sm font-medium rounded-md shadow-sm text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500" data-id="element-22069">
            <UserPlusIcon className="h-4 w-4 mr-1" data-id="element-22070" />
            Add New Vendor
          </button>
          <button onClick={() => setCurrentView('vendors')} className="inline-flex items-center px-4 py-2 border border-gray-300 text-sm font-medium rounded-md shadow-sm text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500" data-id="element-22071">
            <UsersIcon className="h-4 w-4 mr-1" data-id="element-22072" />
            View All Vendors
          </button>
        </div>
      </div>

      {/* Summary Cards */}
      <div className="grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-4 mb-8" data-id="element-22073">
        <button onClick={() => setCurrentView('vendors')} className="bg-white overflow-hidden shadow rounded-lg hover:shadow-md transition-shadow text-left" data-id="element-22074">
          <div className="p-5" data-id="element-22075">
            <div className="flex items-center" data-id="element-22076">
              <div className="flex-shrink-0" data-id="element-22077">
                <UsersIcon className="h-6 w-6 text-gray-400" data-id="element-22078" />
              </div>
              <div className="ml-5 w-0 flex-1" data-id="element-22079">
                <dl data-id="element-22080">
                  <dt className="text-sm font-medium text-gray-500 truncate" data-id="element-22081">
                    Total Vendors
                  </dt>
                  <dd data-id="element-22082">
                    <div className="text-lg font-medium text-gray-900" data-id="element-22083">
                      {totalVendors}
                    </div>
                  </dd>
                </dl>
              </div>
            </div>
          </div>
        </button>

        <button onClick={() => handleViewVendorsByStatus('Active')} className="bg-white overflow-hidden shadow rounded-lg hover:shadow-md transition-shadow text-left" data-id="element-22084">
          <div className="p-5" data-id="element-22085">
            <div className="flex items-center" data-id="element-22086">
              <div className="flex-shrink-0" data-id="element-22087">
                <CheckCircleIcon className="h-6 w-6 text-green-400" data-id="element-22088" />
              </div>
              <div className="ml-5 w-0 flex-1" data-id="element-22089">
                <dl data-id="element-22090">
                  <dt className="text-sm font-medium text-gray-500 truncate" data-id="element-22091">
                    Active Vendors
                  </dt>
                  <dd data-id="element-22092">
                    <div className="text-lg font-medium text-gray-900" data-id="element-22093">
                      {activeVendors}
                    </div>
                  </dd>
                </dl>
              </div>
            </div>
          </div>
        </button>

        <button onClick={() => handleViewVendorsByStatus('Pending Onboarding')} className="bg-white overflow-hidden shadow rounded-lg hover:shadow-md transition-shadow text-left" data-id="element-22094">
          <div className="p-5" data-id="element-22095">
            <div className="flex items-center" data-id="element-22096">
              <div className="flex-shrink-0" data-id="element-22097">
                <ClockIcon className="h-6 w-6 text-blue-400" data-id="element-22098" />
              </div>
              <div className="ml-5 w-0 flex-1" data-id="element-22099">
                <dl data-id="element-22100">
                  <dt className="text-sm font-medium text-gray-500 truncate" data-id="element-22101">
                    Pending Onboarding
                  </dt>
                  <dd data-id="element-22102">
                    <div className="text-lg font-medium text-gray-900" data-id="element-22103">
                      {pendingOnboarding}
                    </div>
                  </dd>
                </dl>
              </div>
            </div>
          </div>
        </button>

        <button onClick={() => setCurrentView('vendors')} className="bg-white overflow-hidden shadow rounded-lg hover:shadow-md transition-shadow text-left" data-id="element-22104">
          <div className="p-5" data-id="element-22105">
            <div className="flex items-center" data-id="element-22106">
              <div className="flex-shrink-0" data-id="element-22107">
                <AlertTriangleIcon className="h-6 w-6 text-yellow-400" data-id="element-22108" />
              </div>
              <div className="ml-5 w-0 flex-1" data-id="element-22109">
                <dl data-id="element-22110">
                  <dt className="text-sm font-medium text-gray-500 truncate" data-id="element-22111">
                    Compliance Issues
                  </dt>
                  <dd data-id="element-22112">
                    <div className="text-lg font-medium text-gray-900" data-id="element-22113">
                      {complianceIssues}
                    </div>
                  </dd>
                </dl>
              </div>
            </div>
          </div>
        </button>
      </div>

      {/* Recent Vendors and Compliance Issues */}
      <div className="grid grid-cols-1 gap-5 lg:grid-cols-2" data-id="element-22114">
        <div className="bg-white shadow overflow-hidden sm:rounded-md mb-8" data-id="element-22115">
          <div className="px-4 py-5 border-b border-gray-200 sm:px-6 flex justify-between items-center" data-id="element-22116">
            <h3 className="text-lg leading-6 font-medium text-gray-900" data-id="element-22117">
              Recently Updated Vendors
            </h3>
            <button onClick={() => setCurrentView('vendors')} className="text-sm text-indigo-600 hover:text-indigo-900" data-id="element-22118">
              View all
            </button>
          </div>
          <ul className="divide-y divide-gray-200" data-id="element-22119">
            {recentVendors.length === 0 ? <li className="px-6 py-4 text-center text-sm text-gray-500" data-id="element-22120">
                No vendors found.
              </li> : recentVendors.map(vendor => <li key={vendor.vendorId} className="px-4 py-4 sm:px-6 hover:bg-gray-50 cursor-pointer" onClick={() => setCurrentView('vendors')} data-id="element-22121">
                  <div className="flex items-center justify-between" data-id="element-22122">
                    <div className="flex items-center" data-id="element-22123">
                      <div className="flex-shrink-0" data-id="element-22124">
                        <UsersIcon className="h-5 w-5 text-gray-400" data-id="element-22125" />
                      </div>
                      <p className="ml-2 text-sm font-medium text-indigo-600 truncate" data-id="element-22126">
                        {vendor.vendorName}
                      </p>
                    </div>
                    <div className="ml-2 flex-shrink-0" data-id="element-22127">
                      {getStatusBadge(vendor.vendorStatus?.name)}
                    </div>
                  </div>
                  <div className="mt-2 sm:flex sm:justify-between" data-id="element-22128">
                    <div className="sm:flex" data-id="element-22129">
                      <p className="flex items-center text-sm text-gray-500" data-id="element-22130">
                        {vendor.type} • {vendor.country}
                      </p>
                    </div>
                    <div className="mt-2 flex items-center text-sm text-gray-500 sm:mt-0" data-id="element-22131">
                      <p data-id="element-22132">
                        Last updated:{' '}
                        <span className="ml-1.5" data-id="element-22133">
                          {new Date(vendor.createdUtc).toLocaleDateString(locale)}
                        </span>
                      </p>
                    </div>
                  </div>
                </li>)}
          </ul>
        </div>

        <div className="bg-white shadow overflow-hidden sm:rounded-md mb-8" data-id="element-22134">
          <div className="px-4 py-5 border-b border-gray-200 sm:px-6 flex justify-between items-center" data-id="element-22135">
            <h3 className="text-lg leading-6 font-medium text-gray-900" data-id="element-22136">
              Compliance Issues
            </h3>
            <button onClick={() => setCurrentView('vendors')} className="text-sm text-indigo-600 hover:text-indigo-900" data-id="element-22137">
              View all
            </button>
          </div>
          <ul className="divide-y divide-gray-200" data-id="element-22138">
            {vendorsWithIssues.length === 0 ? <li className="px-6 py-4 text-center text-sm text-gray-500" data-id="element-22139">
                No compliance issues found.
              </li> : vendorsWithIssues.map(vendor => <li key={vendor.vendorId} className="px-4 py-4 sm:px-6 hover:bg-gray-50 cursor-pointer" onClick={() => setCurrentView('vendors')} data-id="element-22140">
                  <div className="flex items-center justify-between" data-id="element-22141">
                    <div className="flex items-center" data-id="element-22142">
                      <div className="flex-shrink-0" data-id="element-22143">
                        <AlertTriangleIcon className="h-5 w-5 text-yellow-400" data-id="element-22144" />
                      </div>
                      <p className="ml-2 text-sm font-medium text-indigo-600 truncate" data-id="element-22145">
                        {vendor.vendorName}
                      </p>
                    </div>
                    <div className="ml-2 flex-shrink-0" data-id="element-22146">
                      {vendor.isCompliant ? <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-green-100 text-green-800" data-id="element-22147">
                          <CheckCircleIcon className="mr-1 h-3 w-3" data-id="element-22148" />
                          Compliant
                        </span> : <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-red-100 text-red-800" data-id="element-22149">
                          <AlertTriangleIcon className="mr-1 h-3 w-3" data-id="element-22150" />
                          Non-Compliant
                        </span>}
                    </div>
                  </div>
                  <div className="mt-2 sm:flex sm:justify-between" data-id="element-22151">
                    <div className="sm:flex" data-id="element-22152">
                      <p className="flex items-center text-sm text-gray-500" data-id="element-22153">
                        {getComplianceIssue(vendor)}
                      </p>
                    </div>
                    <div className="mt-2 flex items-center text-sm text-gray-500 sm:mt-0" data-id="element-22154">
                      <p data-id="element-22155">
                        <button className="text-indigo-600 hover:text-indigo-900" onClick={e => {
                    e.stopPropagation();
                    setCurrentView('vendors');
                  }} data-id="element-22156">
                          Review
                        </button>
                      </p>
                    </div>
                  </div>
                </li>)}
          </ul>
        </div>
      </div>
    </div>;
}
// Helper function to render status badges
function getStatusBadge(status) {
  switch (status) {
    case 'Active':
      return <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-green-100 text-green-800" data-id="element-22157">
          <CheckCircleIcon className="mr-1 h-3 w-3" data-id="element-22158" />
          {status}
        </span>;
    case 'Pending Onboarding':
    case 'Invited':
      return <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-blue-100 text-blue-800" data-id="element-22159">
          <ClockIcon className="mr-1 h-3 w-3" data-id="element-22160" />
          {status}
        </span>;
    case 'Inactive':
      return <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-gray-100 text-gray-800" data-id="element-22161">
          <UsersIcon className="mr-1 h-3 w-3" data-id="element-22162" />
          {status}
        </span>;
    default:
      return <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-gray-100 text-gray-800" data-id="element-22163">
          {status}
        </span>;
  }
}
function getComplianceIssue(vendor) {
  if (vendor.complianceIssues.length === 0) {
    return 'No specific issues';
  }
  const issue = vendor.complianceIssues[0];
  return issue.notes || issue.complianceIssueType.name;
}